import styled, {css} from 'styled-components'
import {Modal} from '@components/ui/modal-atoms/ModalAtoms.tsx'

export const StyledAccountModalContainer = styled.div(
    () => css`
        display: grid;
        grid-template-rows: 60px 1fr;
    `
)

export const StyledAccountModal = styled(Modal)(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-columns: 0.33fr 1fr;
        height: 720px;
        background: ${palette.neutral[50]};
    `
)

export const StyledAccountModalBody = styled.div(
    ({theme: {palette}}) => css`
        background: ${palette.neutral.white};
    `
)
